module.exports = __webpack_public_path__ + "96eac9710160d93e854a242c4f8edb20.png";